import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PaymentGatewayModal from './PaymentGatewayModal';

function ButtonPayNowDrop({ invoice_data }) {
  const { t } = useTranslation();
  const [showModal, setModal] = useState(false);

  const onClickPayNow = () => {
    setModal(true);
  };

  return (
    <>
      <button onClick={onClickPayNow} className='btn-sm btn-paynow-ipb'>
        <i className="ri-arrow-right-circle-line"></i> {t('pay')}
      </button>

      {showModal && (
        <PaymentGatewayModal
          show={showModal}
          onClose={() => setModal(false)}
          invoice_data={invoice_data}
        />
      )}
    </>
  );
}

export default ButtonPayNowDrop;